import {Component, Input} from '@angular/core';
import {ModalController, IonicModule} from '@ionic/angular';
import {ApplicationSettings, BankContactSettings} from '../../../domain/contact-settings';
import {BankEntity} from '../../../domain/bank-entity';
import {OpenHoursComponent} from '../open-hours/open-hours.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-support-hours-alert',
  imports: [IonicModule, OpenHoursComponent, TranslateModule],
  templateUrl: './support-hours-alert.component.html',
  styleUrls: ['./support-hours-alert.component.scss']
})
export class SupportHoursAlertComponent {
  @Input() isBankHoliday: boolean;
  @Input() isOutsideSupportHours: boolean;

  bankContactSettings: BankContactSettings;
  applicationSettings: ApplicationSettings;
  bankEntity: BankEntity;

  constructor(private readonly modalController: ModalController) {
  }

  dismiss(): void {
    this.modalController.dismiss().then();
  }
}
